import React, { useEffect, useState, useContext } from 'react'
import { IonRow, IonCol, IonToolbar } from '@ionic/react';
import { Button, Titulo, RadioButtonGroup, Modal, TextLink } from 'app-principal-componentes-visuales';
import DetalleAtencion from '../../components/Modals/DetalleAtencion/DetalleAtencion';
import { Casos } from '../../models/caso.model';
import { CANCELAR_SOLICITUD, PREFIJO_MOTIVO, PEDIDO_SERVICIO, COMPONENTE_ASISTENCIA_OFRECIDA, COMPONENTE_ASISTENCIA_DOMICILIO, COMPONENTE_ASISTENCIA_VIRTUAL, FEEDBACK_SERVICIO_EN_CURSO, ASISTENCIA_CREADA, DELAY_REQUEST_CASOS_EN_CURSO, WEB, ADS } from '../../utils/constants';
import { listarSintomas } from '../../utils/utils';
import { AsistenciaMedicaContext } from '../../contexts/AsistenciaMedicaContext';
import { ClasificacionModel } from '../../interfaces/clasificacion.interface';
import ErrorPage from '../ErrorPage/ErrorPage';
import PageWrapper from '../../components/PageWrapper/PageWrapper';
import { TextoComponente } from '../../interfaces/textoComponente.interface';
import { cargarDatos, crearInfoCaso } from '../../helpers/salusHelper';
import { CrearDerivarCasoYsocial, ServiciosMultiplesResponse } from '../../interfaces/ysocial/crearDerivarCasoYsocial.interface';
import { saveCasoServicioYsocial, sendCasoYsocial } from '../../api/ysocial/casoServiceYsocial';
import './PedidoServicio.scss';

const PedidoServicio = ({ history }) => {

    const { clasificaciones, coseguro } = history.location.state;
    const { useRequest, asistenciaMedica, storageManager, isWeb } = useContext(AsistenciaMedicaContext);
    const { apiRequest } = useRequest();
    const [pending, setPending] = useState(false);
    const [servicios, setServicios] = useState([]);
    const [showVerDetalleModal, setShowVerDetalleModal] = useState(false);
    const [visitaMedicaDomicilio, setVisitaMedicaDomicilio] = useState(false);
    const [caso, setCaso] = useState<CrearDerivarCasoYsocial>(null);
    const [error, setError] = useState(false);
    const [sintomaFinal, setSintomaFinal] = useState("");
    const socioSeleccionado = asistenciaMedica.socioSeleccionado;
    const direccionSeleccionada = asistenciaMedica.direccionSeleccionada;
    const sintomas = asistenciaMedica.datosParaTriage.sintomasSeleccionados;
    const preguntas = asistenciaMedica.datosParaTriage.preguntasRespondidas;
    const observacion = asistenciaMedica.datosParaTriage.observaciones;
    const textoComponente: TextoComponente = asistenciaMedica?.textoComponentes?.filter((textoComponente) => textoComponente?.componente === COMPONENTE_ASISTENCIA_OFRECIDA)[0];
    let sintomasSeleccionado;
    let clasificacionSeleccionada;

    /**
     * se arma array con los servicios a mostrar, que le llegan de la pantalla anterior en clasificaciones, para el componente radioButtonGroup.
     */
    useEffect(() => {
        clasificacionSeleccionada = clasificaciones?.[0];
        sintomasSeleccionado = sintomas.concat(listarSintomas(sintomas));
        cargarDatosCasoSalus();
        const filterClasificaciones = clasificaciones?.slice(0, 1);
        const serviciosAux = filterClasificaciones?.map((clasificacion: ClasificacionModel) => {
            return {
                descripcionSolicitud: clasificacion?.clasificacionDetalle?.descripcionSolicitud,
                detalleListado: clasificacion?.clasificacionDetalle?.detalleListado,
                tituloSolicitud: clasificacion?.clasificacionDetalle?.tituloSolicitud,
                servicio: clasificacion?.servicio,
                descripcion: clasificacion?.descripcion
            }
        })

        const serviciosRadioButton = serviciosAux?.map((servicio: any, index) => {
            let comentario, textoComponenteCard;
            if (servicio?.descripcion == 'CV') {
                textoComponenteCard = asistenciaMedica.textoComponentes.filter((textoComponente) => textoComponente.componente === COMPONENTE_ASISTENCIA_DOMICILIO)[0];
                comentario = textoComponenteCard.subtitulo;
            } else if (servicio?.descripcion == 'HCA' || servicio?.descripcion == 'HCD') {
                comentario = 'Uno de nuestros prestadores se estará comunicando dentro de las 24 hs para otorgarte un turno.'
            } else if (servicio?.descripcion == 'CMO' || servicio?.descripcion == 'GEND' || servicio?.descripcion == 'DEND') {
                textoComponenteCard = asistenciaMedica?.textoComponentes?.filter((textoComponente) => textoComponente.componente === COMPONENTE_ASISTENCIA_VIRTUAL)[0];
                comentario = textoComponenteCard?.subtitulo;
            }
            let iconWater = servicio?.descripcion === 'HCA' || servicio?.descripcion === 'HCD';
            let iconComputer = servicio?.descripcion === 'CMO' || servicio?.descripcion === 'GEND' || servicio?.descripcion === 'COVD' || servicio?.descripcion === 'DEND';
            let iconHouse = servicio?.descripcion === 'CV';
            // Se comenta momentaneamente hasta corregir la descripcion del servicio para GEND y COVD
            // let iconClipBoard = servicio?.descripcion === 'GEND' || servicio?.descripcion === 'COVD';
            let iconMedico = servicio?.descripcion === '';

            if (coseguro.coseguroValorFinal > 0) {
                return {
                    iconWater: iconWater,
                    iconComputer: iconComputer,
                    iconHouse: iconHouse,
                    iconMedico: iconMedico,
                    onclick: verDetalleHandler,
                    onClickVerDetalle: () => verDetalleHandler(index),
                    tipoTramite: servicio.tituloSolicitud,
                    value: index.toString(),
                    coseguro: `Coseguro $${coseguro.coseguroValorFinal}`,
                    verDetalle: true,
                    comentario: comentario
                }
            } else {
                return {
                    iconWater: iconWater,
                    iconComputer: iconComputer,
                    iconHouse: iconHouse,
                    iconMedico: iconMedico,
                    onclick: verDetalleHandler,
                    onClickVerDetalle: () => verDetalleHandler(index),
                    tipoTramite: servicio.tituloSolicitud,
                    value: index.toString(),
                    verDetalle: servicio.descripcion === 'CV',
                    comentario: comentario
                }
            }
        })

        setServicios(serviciosRadioButton);
    }, [])

    /**
     * Metodo que se encarga de setear todos los datos necesarios para crear un caso
     */
    const cargarDatosCasoSalus = async () => {
        let prefijomotivo = PREFIJO_MOTIVO;
        let sintoma = prefijomotivo.concat(sintomasSeleccionado[sintomasSeleccionado.length - 1]);
        setSintomaFinal(sintomasSeleccionado[sintomasSeleccionado.length - 1]);
        const caso: CrearDerivarCasoYsocial = await cargarDatos(asistenciaMedica.usuario.ic, socioSeleccionado, sintoma, direccionSeleccionada, preguntas, clasificacionSeleccionada, observacion);
        setCaso(caso);
    }

    /**
     * Metodo que se ejectua al presionar continuar, realizando la llamada a servicio sendCasoSalus, manejo de errores y persistir en la base de datos
     */
    const botonContinuarHandler = async () => {
        setPending(true);

        try {
            const serviciosMultiplesResponse = await sendCasoYsocial(caso, apiRequest);
            if (serviciosMultiplesResponse.status === 207) {
                let serviciosMultiples: ServiciosMultiplesResponse = serviciosMultiplesResponse?.data;
                if (serviciosMultiples?.casos[0].estatus === 200) {
                    const aplicacion = isWeb ? WEB : ADS;
                    let infoCaso = await crearInfoCaso(asistenciaMedica.usuario, socioSeleccionado, sintomaFinal, direccionSeleccionada, serviciosMultiples, observacion, aplicacion);
                    persistirEnBD(infoCaso);
                    const payload = {
                        caso: infoCaso[0].nroCaso,
                        socio: socioSeleccionado,
                        asistenciaValida: true,
                        sendCasoResponse: infoCaso[0]
                    }

                    storageManager.removeDataKeyFromStorage('fechaRequestCasosEnCurso').then(() => history.push(ASISTENCIA_CREADA, payload));
                } else if (serviciosMultiples?.casos[0].estatus === 412) {
                    const payload = {
                        socio: socioSeleccionado
                    }
                    history.push(FEEDBACK_SERVICIO_EN_CURSO, payload);
                } else {
                    console.error("Se produjo un error al pedir una asistencia: ", error);
                    setError(true);
                }
            }
        } catch (error) {
            console.error("Ocurrió un problema al pedir una asistencia: ", error);
            setError(true);
        } finally {
            setPending(false);
        }
    }

    /**
     * Metodo que se encarga de crear un objeto infoCaso y guardarlo en la base de datos
     */
    const persistirEnBD = async (infoCaso) => {
        if (infoCaso.length > 0) {
            try {
                let casos: Casos = new Casos();
                casos.casos = infoCaso;
                casos.numeroIc = asistenciaMedica.usuario.ic.toString();
                const persistirEnBDResponse = await saveCasoServicioYsocial(casos, apiRequest);

                if (persistirEnBDResponse.status === 200) {
                    console.info(`Caso guardado correctamente en la db.`);
                }
            } catch (error) {
                console.error("Error al persistir en bd: ", error);
                setError(true)
            }
        }
    }

    /**
     * Compara los datos basico del socio para comprobar que no se trate del mismo.
     */
    const compararDosSocios = (socioUno, socioDos) => {
        return socioUno.nombre === socioDos.nombre &&
            socioUno.apellidos === socioDos.apellidos &&
            socioUno.id === socioDos.id;
    }

    /**
     * metodo para abrir el modal de ver detalle atencion
     */
    const verDetalleHandler = (index) => {
        const tipoServicio = clasificaciones.filter((servicio) => servicio.descripcion === 'CV')
        if (tipoServicio.length > 0) {
            setVisitaMedicaDomicilio(true);
        }
        setShowVerDetalleModal(true);
    }

    /**
     * metodo que se ejectua al presionar cancelar
     */
    const cancelarHandler = () => {
        history.push(CANCELAR_SOLICITUD, { from: history.location.pathname })
    }

    if (error) {
        return <ErrorPage setError={setError} />
    }

    return (
        <>
            <PageWrapper
                className='verificar-datos-grid'
                pageClassName={isWeb ? 'asistencia__pedidoServicio' : 'asistencia__pedidoServicio asistencia__pedidoServicio-mobile'}
                socio={asistenciaMedica.usuario}
                path={PEDIDO_SERVICIO}
            >
                <div>
                    <IonRow className='pedido-servicio--row'>
                        <IonCol size='12'>
                            <Titulo
                                className='pedidoServicio__title'
                                titulo={textoComponente?.titulo}
                                id="asistencia-pedido-servicio"
                            />
                        </IonCol>
                    </IonRow>

                    <RadioButtonGroup
                        asistencia
                        id="asistencia-radio-button"
                        onClick={() => { }}
                        radioList={servicios}
                        titulo=""
                        valueSelected="0"
                    />
                </div>
                <IonToolbar className='ion-no-border'>
                    <TextLink
                        id="pedido-servicio-cancelar"
                        onClick={cancelarHandler}
                        texto={textoComponente?.botones?.find(btn => btn.nombre === 'boton-cancelar-ao').texto}
                        txt14
                        className='cancelar__button'
                    />
                    <Button
                        id='pedido-servicio-solicitar-asistencia'
                        className='footer__button'
                        primary
                        label={textoComponente?.botones?.find(btn => btn.nombre === 'boton-solicitar-ao').texto}
                        onClick={botonContinuarHandler}
                        waiting={pending}
                    />
                </IonToolbar>
            </PageWrapper>
            <Modal
                className='modal_web'
                hideCloseBtn={false}
                //@ts-ignore
                component={
                    <DetalleAtencion
                        excepcionCoseguro={0}
                        coseguro={coseguro}
                        visitaMedicaDomicilio={visitaMedicaDomicilio}
                        codigoSeguridad={false}
                    />}
                setShowModal={setShowVerDetalleModal}
                showModal={showVerDetalleModal}
                id="detalle-atencion-modal"
            />
        </>
    )
}

export default PedidoServicio;